import React, { useState, useEffect, useMemo } from 'react';

import Select from 'react-select';

export default function MultiUserSelectorInput({ selectedIds, fetchUrl, onChange, disabled, usersList = [], fetchIfNoUsers = true, ...props }) {
    const [users, setUsers] = useState(usersList);

    const value = useMemo(() => users?.filter((user) => selectedIds.includes(user.id)) || [], [selectedIds, users]);

    useEffect(() => {
        let isMounted = true;

        if (usersList.length > 0) {
            setUsers(usersList);
        } else if (fetchIfNoUsers) {
            if (!fetchUrl) {
                // See UserSelectorInput: a role that cannot list users leaves the
                // provider's list empty, and throwing here blanked the whole
                // surrounding panel. Render with no options instead.
                console.warn('MultiUserSelectorInput: no users and no fetchUrl — rendering an empty list');

                return;
            }

            axios
                .get(fetchUrl)
                .then(({ data }) => {
                    if (isMounted) {
                        setUsers(data?.data || []);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <Select
            className="react-select-container"
            classNamePrefix="react-select"
            isMulti
            {...props}
            value={value}
            onChange={(value) => onChange(value.map((v) => v.id))}
            options={users}
            getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
            getOptionValue={(option) => option.id}
            isDisabled={disabled}
        />
    );
}
